import React from 'react';
import { observer } from 'mobx-react';
import CompanyListService from '../services/CompanyListService';
import CompanyListFilter from './CompanyListFilter';

const CompanyListFilterContainer = () => (
  <CompanyListFilter
    values={CompanyListService.form.getValues()}
    onSearch={CompanyListService.load}
    onChange={CompanyListService.form.setValue}
  />
);

export default observer(CompanyListFilterContainer);
